import BottomUpModalContent from './BottomUpModalContent';
import BottomUpModalHeader from './BottomUpModalHeader';
import BottomUpModalWrapper from './BottomUpModalWrapper';
export var BottomUpModal = {
  Wrapper: BottomUpModalWrapper,
  Header: BottomUpModalHeader,
  Content: BottomUpModalContent
};
export default BottomUpModal;